import {createProjectModel} from 'crm/utils/project-model'
import {tasksInfo} from './service'

const model = createProjectModel({
    projectNamespace: 'GroupSopInfo',

    state: {},

    effects: {
        *tasksInfo({payload}, {call}) {
            return yield call(tasksInfo, payload)
        },
    },
})

export default model
